import { ThreeDots } from "react-loader-spinner";
import React from "react";

function Loder() {
  return (
    <>
      <div style={{ height: "157px" }}></div>
      <div
        style={{
          widht: "100px",
          height: "200px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ThreeDots
          height="120"
          width="80"
          radius="5"
          color="green"
          ariaLabel="loading"
          wrapperStyle
          wrapperClass
        />
      </div>
    </>
  );
}

export default Loder;
